import type { Player } from '@schibsted-svp/web-player';
import { Provider } from '@vgtv/api-client';
import { getRawAsset } from './asset';

export const getConfigProvider = (player: Player): Provider => {
  return player.getRawConfig().vendor as Provider;
};

export const getAssetProvider = (player: Player): Provider | 'brandstudio' => {
  return getRawAsset(player)?.provider || getConfigProvider(player);
};

export const getJWPlayerProvider = (player: Player) => {
  return player.getJWPlayer()?.getProvider()?.name;
};
